import { useCallback, useState } from 'react';
import { useHttpFetchApi } from '../http/useHttpFetch';
import { StudyQualification } from '../../models/StudyQualification';

export function useGetStudyQualification() {
  const [studyQualification, setStudyQualification] = useState<
    StudyQualification | undefined
  >();
  const { loading, error, getJson } = useHttpFetchApi();

  const getStudyQualification = useCallback(
    async (studyParticipantId: number) => {
      const studyQualification = await getJson<StudyQualification | undefined>(
        `study-participants/${studyParticipantId}/study-qualification`
      );
      setStudyQualification(studyQualification);
      return studyQualification;
    },
    [getJson]
  );

  return {
    studyQualification,
    loadingStudyQualification: loading,
    loadingStudyQualificationError: error,
    getStudyQualification
  };
}
